import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M14 19a6 6 0 0 0-12 0", stroke: `${color}` }),
        /* @__PURE__ */ jsx(_Circle, { cx: "8", cy: "9", r: "4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(_Circle, { cx: "19", cy: "11", r: "2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M19 8v1", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M19 13v1", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m21.6 9.5-.87.5", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m17.27 12-.87.5", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m21.6 12.5-.87-.5", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m17.27 10-.87-.5", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "UserCog2";
const UserCog2 = memo(themed(Icon));
export {
  UserCog2
};
//# sourceMappingURL=user-cog-2.js.map
